export function showPorcetage(value:number|null,total:number,formatter?:(s:any)=>string){
    let porcetageStr='';
    if(value&&total>0){
       let porcetage=value/total;
       porcetage*=100;
       porcetageStr=` (${porcetage.toFixed(1)}%)`; 
    }
    return `${formatter?formatter(value):value}${porcetageStr}`
}
